import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import "./superAdmin.css";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { basePath } from '../Constants/constant';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark } from '@fortawesome/free-solid-svg-icons'
import RefreshButton from '../Usables/RefreshButton';
import PageBanner from '../Usables/PageBanner';
import { AppContext } from '../ContextApi/ContextApi';

function ModuleManager(props) { 
    const { apiHeaderJSON} = useContext(AppContext);
    const [moduleData, setModuleData] = useState({id: "", module_name: "", module_url: ""});
    const [isAction, setIsAction] = useState(false);
    const [editModal, setEditModal] = useState(false);
    const [allModules, setAllModules] = useState([]);
    const [moduleModal, setModuleModal] = useState(false);
    const [loading, setLoading] = useState(true);

    const getModuleData = async () => {
        try {
            setLoading(true);
            let response = await axios.get(`${basePath}/getmodules`);
            // console.log(response);
            setAllModules(response?.data);
            setLoading(false);
        } catch (error) {
            console.log(error);
            setLoading(false);
        }
    }

    const handleModule = (e) => {
        e.preventDefault();
        const data = {
            module_name: moduleData?.module_name,
            module_url: moduleData?.module_url,
        }
        // console.log(data);
        if (moduleData.module_name && moduleData.module_url) {
            setLoading(true);
            const options = {
                url: `${basePath}/module`,
                method: "POST",
                headers: {
                     ...apiHeaderJSON,
                },
                data: data,
            }
            axios(options)
                .then((response) => {
                    if (response.status === 200) {
                        setLoading(false);
                        getModuleData();
                        // document.getElementById("addModule").reset();
                        setModuleData({
                            id: "",
                            module_name: "",
                            module_url: ""
                        })

                        setModuleModal(false);
                        toast.success("Module Created Successfully");
                    }
                    else {
                        setLoading(false);
                        toast.error("Unable to add module");
                    }
                })
                .catch((e) => {
                    setLoading(false);
                    toast.error("Unable to add module");
                });
        }
        else {
            toast.error("kindly fill the complete form");
        }
    }
    const checkAllFields = () => {
        if (!moduleData.module_name && !moduleData.module_url) {
            toast.error();
        }
    }
    useEffect(() => {
        getModuleData();
    }, []);
    const handleUpdateModule = (e) => {
        e.preventDefault();
        let data = {
            module_name: moduleData?.module_name,
            module_url: moduleData?.module_url,
        }
        if (moduleData.module_name && moduleData.module_url && moduleData.id) {
            setLoading(true);
            const options = {
                url: `${basePath}/updatemodule/${moduleData?.id}`,
                method: "PUT",
                headers: {
                    ...apiHeaderJSON,
                },
                data: data,
            }
            axios(options)
                .then((response) => {
                    if (response.status === 200) {
                        getModuleData();
                        document.getElementById("updateModule").reset();
                        toast.success("Module Updated Successfully");
                        setEditModal(false);
                        setModuleData({ id: "", module_name: "", module_url: "" });
                    }
                    setLoading(false);
                })
                .catch((e) => {
                    setLoading(false);
                });
        }
        else {
            toast.error();
        }
    }
    const handleEdit = (idx) => {
        setModuleData({
            id: allModules[idx]?.id,
            module_name: allModules[idx]?.module_name,
            module_url: allModules[idx]?.module_url,
        })
        setEditModal(true);
        setIsAction(false);
    }
    const handleDelete = (e, id) => {
        if (id) {
            setLoading(true);
            const options = {
                url: `${basePath}/deletemodule/${id}`,
                method: "DELETE",
                headers: {
                    ...apiHeaderJSON,
                },
            }
            axios(options)
                .then((response) => {
                    if (response.status === 200) {
                        getModuleData();
                        toast.success("Module Deleted Successfully");
                    }
                    else {
                        toast.error("Unable to delete");
                    }
                    setLoading(false);
                })
                .catch((e) => {
                    toast.error("Unable to delete");
                    setLoading(false);
                });
        }
        else {
            toast.error();
        }
    }
    return (
        <section onClick={() => { setIsAction(false); }} className='lightBabyGreen relative w-full mb-10'>
            {/* RefreshButton => used for refresh table data */}
            <RefreshButton onClick={getModuleData} position='fixed' />
            <div className=' m-auto '>
                {/* PageBanner => used to show page banner info */}
                <PageBanner pageName='Module Master' pageTitle='Ready to start your day' src='/img/master.png' alt="Module Master" />
                <div onClick={(e) => {
                    setModuleModal(true); setModuleData([{module_name: "", module_url: ""}])
                }} className='darkPurple w-fit my-2 cursor-pointer rounded-full py-2 px-3 text-white flex items-center gap-2 font-bold grayBlurShadow hoverGreen navAnimation'><img className=' w-8 ' src="/img/addBtn.png" alt="" /> <button>Add New Modules</button></div>
            </div>
            <div className=' '>
                {moduleModal ?
                    <div onClick={() => { setModuleModal(false); }} className=' w-full h-screen fixed left-0 top-0 flex items-center justify-center blurBack z-50'>
                        <form id='addModule' onClick={(e) => { e.stopPropagation(); }} onSubmit={handleModule} className='relative flex flex-col gap-2 items-center navAnimation py-5 px-10 bg-white grayBlurShadow rounded-2xl addModuleBox'>
                            <button onClick={(e) => { setModuleModal(false); }} className="absolute bg-red-600 px-1.5 py-0.5    rounded-full w-fit top-1 right-1 z-[11] ">
                                <FontAwesomeIcon icon={faXmark} size='xl' style={{ color: "#ffffff", }} />
                            </button>
                            <h1 className=' text-3xl font-semibold babyGreen w-full py-3 mb-3 rounded-lg'>Add Module</h1>
                            <div className=' flex flex-col items-center h-full gap-4 w-full'>
                                <div className='input-group relative w-full mb-3'>
                                    <input value={moduleData?.module_name} onChange={(e) => { setModuleData({ ...moduleData, module_name: e.target.value }); }} autoComplete='off' id='module' placeholder='Module Name' className=' w-full' required type="text" />
                                    <label htmlFor="module" className='label'>Module Name</label>
                                </div>
                                <div className='input-group relative w-full '>
                                    <input value={moduleData?.module_url} onChange={(e) => { setModuleData({ ...moduleData, module_url: e.target.value }); }} autoComplete='off' id='url' placeholder='URL*' className=' w-full' required type="text" />
                                    <label htmlFor="url" className='label'>URL</label>
                                </div>
                            </div>
                            <button type='submit' onClick={checkAllFields} className=' darkPurple text-white py-2 px-5 rounded-lg mt-5 hoverGreen font-semibold'>{!loading ? "Submit" : <img className=' h-7  py-1' src="/img/loadingBlue.webp" alt="Loading..." />}</button>
                        </form>
                    </div> : null}
                {editModal ?
                    <div onClick={() => { setEditModal(false); setModuleData({ id: "", module_name: "", module_url: "" }); }} className=' w-full h-screen fixed left-0 top-0 flex items-center justify-center blurBack z-50'>
                        <form id='updateModule' onClick={(e) => { e.stopPropagation(); }} onSubmit={handleUpdateModule} className='relative flex flex-col gap-2 items-center navAnimation py-5 px-10 bg-white grayBlurShadow rounded-2xl addModuleBox'>
                            <button onClick={(e) => { setEditModal(false); setModuleData({ id: "", module_name: "", module_url: "" }); }} className="absolute bg-red-600 px-1.5 py-0.5    rounded-full w-fit top-1 right-1 z-[11] ">
                                <FontAwesomeIcon icon={faXmark} size='xl' style={{ color: "#ffffff", }} />
                            </button>
                            <h1 className=' text-3xl font-semibold babyGreen w-full py-3 mb-3 rounded-lg'>Update Module</h1>
                            <div className=' flex flex-col items-center h-full gap-4 w-full'>
                                <div className='input-group relative w-full mb-3'>
                                    <input value={moduleData?.module_name} onChange={(e) => { setModuleData({ ...moduleData, module_name: e.target.value }) }} autoComplete='off' id='module' placeholder='Module Name' className=' w-full' required type="text" />
                                    <label htmlFor="module" className='label'>Module Name</label>
                                </div>
                                <div className='input-group relative w-full '>
                                    <input value={moduleData?.module_url} onChange={(e) => { setModuleData({ ...moduleData, module_url: e.target.value }) }} autoComplete='off' id='url' placeholder='URL*' className=' w-full' required type="text" />
                                    <label htmlFor="url" className='label'>URL</label>
                                </div>
                            </div>
                            <button type='submit' onClick={checkAllFields} className=' darkPurple text-white py-2 px-5 rounded-lg mt-5 hoverGreen font-semibold'>{!loading ? "Submit" : <img className=' h-7 py-1' src="/img/loadingBlue.webp" alt="Loading..." />}</button>
                        </form>
                    </div> : null}
                <div className=' grayBlurShadow rounded-3xl p-5 bg-white  '>
                    {!loading ?
                        <>
                            {Array.isArray(allModules) && allModules?.length >= 1 ?
                                <div className='  overflow-y-scroll customScroll tableBox'>
                                    <table className=' w-full navAnimation '>
                                        <thead className=' bg-gray-300 rounded-lg text-xl headingRow z-10'>
                                            <tr>
                                                <th>Sr. No.</th>
                                                <th>Module Name</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody className=' font-semibold ' >
                                            {allModules?.map((val, idx) => {
                                                return (
                                                    <tr key={val?.madule_id} className='backWhite'>
                                                        <td>{idx + 1}</td>
                                                        <td>{val?.module_name}</td>
                                                        <td className='  flex justify-center items-center'>
                                                            <div className='relative w-fit'>
                                                                <div onClick={(e) => { e.stopPropagation(); setIsAction(val?.id); }} className=' flex flex-row gap-1 cursor-pointer w-fit p-2 rounded-lg hoverGreen'>
                                                                    <div className=' w-2 h-2 darkPurple rounded-full '></div>
                                                                    <div className=' w-2 h-2 darkPurple rounded-full '></div>
                                                                    <div className=' w-2 h-2 darkPurple rounded-full '></div>
                                                                </div>
                                                                {isAction === val?.id ?
                                                                    < div className={`absolute ${allModules?.length - 2 <= idx && allModules?.length > 2 ? "bottom-5 z-10 right-2" : "right-2 z-10 top-5"} w-40 h-fit p-3 rounded-xl border-2 bg-white grayBlurShadow`} >
                                                                        <div className='flex flex-col'>
                                                                            <button onClick={() => { handleEdit(idx); }} className=' text-yellow-600 bg-yellow-200 m-2 px-4 py-1 rounded-lg hoverYellow' >Edit</button>
                                                                            <button onClick={(e) => { handleDelete(e, val?.id) }} className=' text-red-700 bg-red-200 mx-2 px-2 py-1 rounded-lg hoverRed'>Delete</button>
                                                                        </div>
                                                                    </div> : null
                                                                }
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                </div> :
                                <div className=' flex flex-col items-center mt-5'>
                                    <img className=' w-1/4' src="/img/addReports.png" alt="" />
                                    <h1 className=' text-xl font-bold'>Oops!! "<span className=' text-blue-950'>No Modules Found!!!</span>"</h1>
                                </div>}
                        </> :
                        <div className=' loaderBox mb-5 bg-white mt-5 rounded-3xl '>
                            <img className=' m-auto w-[28%]' src="/img/loader2.gif" alt="loading..." />
                        </div>
                    }
                </div>
            </div>
        </section >
    );
}

export default ModuleManager;